<template>
		<div class="content home-page">
      <div class="bgfff">
        <Header></Header>
        <div class="nav ac">
          <div class="back" @click="back">
            <img width="40" src="../../static/images/back2.png" />
          </div>
          {{$t('guidance')}}
        </div>
      </div>
      <div class="info">

        <div class="information2">
          <div class="faq-content" v-if="list!=''">
            <div class="">
              <p class="mt30" v-html="list"></p>
            </div>
          </div>
        </div>
      </div>

		</div>
</template>
<script>
import Header from '../components/Header'
export default {
    components:{
		Header
    },
    data() {
        return {
			list:[]

		}
    },
	created(){
		this.getHome();
	},
    methods: {
		back(){
			this.$router.go(-1);
		},
		getHome(){
			let that =this;
			that.$parent.loadModal(true);
      let data = {
        type:'3'
      }
			that.$api.post('/api/index/help',data,r =>{
				that.$parent.returnCode(r,function(){
          that.$parent.loadModal(false);
          if(localStorage.getItem('lang')=='en'){
            that.list = r.data.content
          }else{
            that.list = r.data.mm_content
          }
					that.$parent.loadModal(false);
				});

			})

		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/guidance.vue